import { Image, Play } from 'lucide-react'

type Props = { label: string; kind?: 'image' | 'video'; ratio?: 'wide' | 'portrait' | 'square'; className?: string }

export function MediaPlaceholder({ label, kind = 'image', ratio = 'wide', className = '' }: Props) {
  const Icon = kind === 'video' ? Play : Image
  return (
    <div className={`media-placeholder media-${ratio} ${className}`} role="img" aria-label={`Placeholder: ${label}`}>
      <span className="media-grid" aria-hidden="true" />
      <Icon size={28} strokeWidth={1.5} />
      <strong>{kind === 'video' ? 'Vídeo' : 'Imagem'} a substituir</strong>
      <small>{label}</small>
    </div>
  )
}
